"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const i18next_1 = __importDefault(require("i18next"));
function default_1({ confirm, openCompanyRegisterDialog, }) {
    confirm({
        description: i18next_1.default.t('사업자 정보가 부족하여 세금계산서를 발행할 수 없어요. 사업자 정보 등록해 주세요!'),
        confirmationText: i18next_1.default.t('사업자 정보 등록'),
    })
        .then(openCompanyRegisterDialog)
        .catch(() => { });
}
exports.default = default_1;
